<template>
  <v-layout
    align-center
    lg10
  >
    <v-flex
      v-if="false"
      lg6
    >
      <v-img
        :src="companyLogo"
        min-width="50px"
        max-height="50px"
      />
    </v-flex>
    <v-flex
      lg6
    >
      <v-menu :nudge-width="100">
        <v-btn
          slot="activator"
          flat
        >
          <span
            class="title"
          >{{ _company }}</span>
          <v-icon dark>
            arrow_drop_down
          </v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="company in companies"
            :key="company.id"
            :data="company"
            :class="(company.abbreviation === _company ? 'list__tile--active' : '')"
            @click="switchCompany(company.abbreviation)"
          >
            <v-list-tile-title> <span>{{ company.abbreviation }}</span></v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import laroute from '~/laroute'

export default {
  name: 'CompanyDropdown',
  data: () => ({
    companies: {}
  }),
  computed: {
    ...mapGetters({
      _company: 'auth/company',
      user: 'auth/user'
    }),
    companyLogo () {
      return '/images/' + this._company + '-logo.png'
    }
  },
  created () {
    this.getCompanies()
  },
  methods: {
    async getCompanies () {
      const { data } = await axios.get(laroute.route('get_user_companies', { userId: this.user.id }))

      this.companies = data
    },
    switchCompany (companyId) {
      this.$store.commit('auth/saveCompany', { company: companyId }, { root: true })
      const route = this.$route.name.replace(/create|view|edit/gi, 'list')
      this.$router.push({ name: route, params: { companyId: companyId } })
    }
  }
}
</script>

<style scoped>
  .v-menu__content {
    z-index: 15 !important;
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/components/CompanyDropdown.vue